import { render, staticRenderFns } from "./AddIssue.vue?vue&type=template&id=0c80e7db"
import script from "./AddIssue.vue?vue&type=script&lang=js"
export * from "./AddIssue.vue?vue&type=script&lang=js"
import style0 from "./AddIssue.vue?vue&type=style&index=0&id=0c80e7db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports